import React from 'react';
import './style.scss';

export default function MobileNotice() {
  return (
    <div className="mobile-notice">
      <div className="mobile-notice__icon">
        <i className="fas fa-mobile-alt" />
      </div>
      <p className="mobile-notice__title">Звертаємо Вашу увагу!</p>
      <p className="mobile-notice__text">
        Сайтом можливо користуватись також через будь-який браузер
        на Вашому мобільному телефоні
      </p>
    </div>
  );
}
